import {EventSource} from 'eventsource';

let eventSourceInstances = {
    jobs: null,
    output: null,
};

let isConnectDict = {
    jobs: false,
    output: false
}


export const getEventSource = (SSE_URL, channel) => {
    const token = localStorage.getItem('sessionToken');
    const eventSourceInstance = eventSourceInstances[channel]
    if ((!eventSourceInstance || eventSourceInstance.readyState === 2) && token ) {
        // readyState 2 === CLOSED
        eventSourceInstances[channel] = new EventSource(SSE_URL, {
            fetch: (input, init) =>
                fetch(input, {
                    ...init,
                    headers: {
                        ...init.headers,
                        Authorization: `Bearer ${token}`,
                    },
                }),
        })
        isConnectDict[channel] = false;
    } else {
        console.warn(`${channel} - An instance of sse connection has already been instantiated`);
        isConnectDict[channel] = true;
    }

    return { eventSource: eventSourceInstances[channel], isConnect: isConnectDict[channel] };

}


export const closeEventSource = (channel) => {
    const eventSourceInstance = eventSourceInstances[channel]
    if (eventSourceInstance && eventSourceInstance.readyState !== 2) {
        eventSourceInstance.close();
        eventSourceInstances[channel] = null;
    }
};